import { InputNumber, Tooltip } from "antd";
import { useDataTableEditableColumn } from "~components/DataTable/hooks/useDataTableEditableColumn.ts";

type Props = {
  value?: number | null;
  isEditMode: boolean;
  disabled?: boolean;
  required?: boolean;
  min?: number;
  max?: number;
  onSave?: (value: number | null) => void | Promise<void>;
};

const getInitialValue = (value?: number | null) => value ?? null;
const isEmpty = (value: number | null) => value === null;

export const DataTableNumberColumn = ({ value, isEditMode, disabled = false, required = false, min, max, onSave }: Props) => {
  const { inputValue, setInputValue, loading, errorMessage, clearErrorMessage, handleSave } =
    useDataTableEditableColumn({
      value,
      required,
      onSave,
      isEmpty,
      getInitialValue,
    });

  if (!isEditMode) {
    return value ?? "";
  }

  return (
    <Tooltip title={errorMessage} open={errorMessage ? true : undefined}>
      <InputNumber
        disabled={disabled || loading}
        status={errorMessage ? "error" : undefined}
        style={{ width: "100%" }}
        value={inputValue}
        min={min}
        max={max}
        onChange={(nextValue) => {
          setInputValue(nextValue ?? null);
          clearErrorMessage();
        }}
        onBlur={() => void handleSave()}
        onPressEnter={() => void handleSave()}
      />
    </Tooltip>
  );
};
